/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SMSearchFormWarningsData
 */
export interface SMSearchFormWarningsData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMSearchFormWarningsData
     */
    fareTypes?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMSearchFormWarningsData
     */
    preferredCarriers?: ValidationMessage;
}

export function SMSearchFormWarningsDataFromJSON(json: any): SMSearchFormWarningsData {
    return SMSearchFormWarningsDataFromJSONTyped(json, false);
}

export function SMSearchFormWarningsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMSearchFormWarningsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fareTypes': !exists(json, 'fareTypes') ? undefined : ValidationMessageFromJSON(json['fareTypes']),
        'preferredCarriers': !exists(json, 'preferredCarriers') ? undefined : ValidationMessageFromJSON(json['preferredCarriers']),
    };
}

export function SMSearchFormWarningsDataToJSON(value?: SMSearchFormWarningsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fareTypes': ValidationMessageToJSON(value.fareTypes),
        'preferredCarriers': ValidationMessageToJSON(value.preferredCarriers),
    };
}


